import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Card, Col, FormGroup, Label, Row } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import TeamSelect from "../../../../Components/Common/TeamSelect";
import EmployeeSelect from "../../../../Components/Common/EmployeeSelect";
import { DatePicker } from "../../../../Components/Common/Flatpicker";
import { LeadDataTable } from "../../../../Components/Common/DashboardDataTbale";
import { getPreviousDate, setCurrentDate } from "../../../../Components/Common/DefaultDateSet";
import { formatFlatPickerDates, getBackgroundColor } from "../../../../Components/Common/ToCamelCase";
import { CommonLabel } from "../../../../Components/Common/CommonLabel";
import { MultiSelect } from "react-multi-select-component";
import { useSelector } from "react-redux";
import { LEAD_STATUS_REPORT } from "../../../../helpers/url_helper";
import { APIClient } from "../../../../helpers/api_helper";
import moment from "moment";
import { useProfileData } from "../../../../Components/Hooks/UserHooks";
import CalculateRemainingDays from "../../../../Components/Common/CalculateRemainingDays";
import SubExpired from "../../../../Components/Common/subExpired";
const api = new APIClient();


const LeadStatusReport = () => {
    const { statusOptions } = useSelector(state => state.leadStatusReducer);
    const [getLeadStatus, setGetLeadStatus] = useState([]);
    // default date 
    const previewsDate = getPreviousDate();
    const currentDate = setCurrentDate();


    // date picker state
    const [selectedFromDate, setSelectedFromDate] = useState(previewsDate);
    const [selectedToDate, setSelectedToDate] = useState(currentDate);

    // Memoized formatted dates
    const formattedDates = useMemo(() =>
        formatFlatPickerDates(selectedFromDate, selectedToDate),
        [selectedFromDate, selectedToDate]
    );

    // Memoized date object using formattedDates
    const dateObj = useMemo(() => ({
        startDate: formattedDates.formattedStartDate,
        endDate: formattedDates.formattedEndDate,
    }), [formattedDates]);

    const [EmployeeData, setEmployeeData] = useState([]);
    const [teamIndu, setTeamIndu] = useState([]);

    const [leadStatusReport, setLeadStatusReport] = useState([])
    // employee wise state
    const [selectedEmployeeOptions, setSelectedEmployeeOptions] = useState([]);
    const [selectedEmployeeOptions2, setSelectedEmployeeOptions2] = useState([]);
    const [EmployeeDefaultWithoutTeam, setEmployeeDefaultWithoutTeam] = useState([]);
    const [prevEmployeesIds_Test, setPrevEmployeesIds_Test] = useState([]);
    const [prevstatus_Test, setPrevstatus_Test] = useState([]);
    const [isFirstEffectRun, setIsFirstEffectRun] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // error message show in not a select empty
    const [error, setError] = useState("");
    const [statusError, setStatusError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);

    const [isExpiredModalOpen, setIsExpiredModalOpen] = useState(true);
    const navigate = useNavigate();
    const { profileData } = useProfileData();
    const remainingDays = CalculateRemainingDays();


    const handleFromDateChange = (dates) => {
        setSelectedFromDate(dates[0]);
    };


    // To Date function 
    const handleToDateChange = (dates) => {
        setSelectedToDate(dates[0]);
    };

    // filter status select function
    const handleStatusChange = (selectedOptions) => {
        if (selectedOptions) {
            setGetLeadStatus(selectedOptions)
            setStatusError('')
        }
    }

    const handleClose = () => {
        setIsExpiredModalOpen(false);
        navigate("/planPackage");
      };

      
    const columns = [
        {
            name: <span className="font-weight-bold fs-13">S No.</span>,
            selector: (row, index) => index + 1,
            sortable: false,
            width: "80px",
        },
        {
            name: <span className="font-weight-bold fs-13">Lead Name</span>,
            selector: (row) => row.firstName,
            cell: (row) => (
                <div className="d-flex align-items-center">
                    {row.profileImageUrl ? (
                        <img
                            src={row.profileImageUrl}
                            alt="Profile"
                            style={{
                                width: "35px",
                                height: "35px",
                                objectFit: "cover",
                                borderRadius: "50%",
                                marginRight: "10px",
                            }}
                        />
                    ) : (
                        <div
                            className="rounded-circle d-flex justify-content-center align-items-center"
                            style={{
                                width: "35px",
                                height: "35px",
                                background: getBackgroundColor(row.firstName),
                                marginRight: "10px",
                                fontWeight: "bold",
                                color: "#fff",
                            }}
                        >
                            {row.firstName ? row.firstName.charAt(0).toUpperCase() : "?"}
                        </div>
                    )}
                    <span>{row.firstName}   {row.lastName}</span>
                </div>
            ),
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Created Date</span>,
            selector: (row) => row.createdAt,
            cell: (row) => <span>{moment(row.createdAt).format('DD  MMM  YYYY') || "-"}</span>,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Assign To </span>,
            selector: (row) => row.assignedTo[0].fullName || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Lead Number </span>,
            selector: (row) => row.phone || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">No of Attempts</span>,
            selector: (row) => row?.leadCallDetails?.outgoingCount || "-",
            sortable: true,
        },
     
        // {
        //     name: <span className="font-weight-bold fs-13">Reminder Date</span>,
        //     selector: (row) => row.statusReminderDate || "-",
        //     sortable: true,
        // },
        {
            name: <span className="font-weight-bold fs-13">Last Modified Date</span>,
            selector: (row) => row.updatedAt,
            cell: (row) => <span>{moment(row.createdAt).format('DD  MMM  YYYY') || "N/A"}</span>,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Last Call Summary</span>,
            selector: (row) => row?.leadCallDetails?.lastCallSummry || "-",
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Lead Status</span>,
            selector: (row) => row.status,
            cell: (row) => <span>{row.status || "-"}</span>,
            sortable: true,
            key: "status",
        },
    ];


    // api credentials pass in function 
    const getRequestData = useCallback(
        (updatedIds = [], leadsStatus = [], dateObj = {}) => {
            return {
                employeeIds: updatedIds || selectedEmployeeOptions2.map(userid => userid?.id),
                leadStatus: leadsStatus || getLeadStatus?.map(lead => lead?.value),
                startDate: dateObj.startDate,
                endDate: dateObj.endDate,
            };
        },
        [formattedDates, selectedEmployeeOptions2, getLeadStatus]
    );


    // all api fetch data 
    const fetchLeadStatusReport = useCallback(
        async (updatedIds = [], leadsStatus = [], dateObj = {}, currentPage, perPage) => {
            setIsLoading(true);
            try {
                // Get request payload
                const requestData = getRequestData(
                    updatedIds,
                    leadsStatus,
                    dateObj
                );
                const response = await api.create(`${LEAD_STATUS_REPORT}?pg=${currentPage}&lm=${perPage}`, requestData);
                if (response?.success) {
                    setLeadStatusReport(response.data.leads)
                    setTotalRows(response.data.totalCount)
                }
            } catch (error) {
                console.error("Error fetching report:", error);
            } finally {
                setIsLoading(false);
            }
        },
        [getRequestData]
    );

    // default data show in DataTable
    useEffect(() => {
        if (teamIndu) {
            if (!isFirstEffectRun && selectedEmployeeOptions?.length > 0) {
                let leadsStatus = prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
                let updatedIds = prevEmployeesIds_Test.length > 0 ? prevEmployeesIds_Test : selectedEmployeeOptions2?.map((option) => option?.id) || [];
                if (updatedIds.length > 0) {

                    fetchLeadStatusReport(updatedIds, leadsStatus, dateObj, currentPage, perPage);
                }
                setIsFirstEffectRun(true);
                setPrevEmployeesIds_Test(updatedIds)
                setPrevstatus_Test(leadsStatus)
            }
        } else {
            let leadsStatus = prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
            let updatedIds = prevEmployeesIds_Test.length > 0 ? prevEmployeesIds_Test : EmployeeDefaultWithoutTeam?.map((option) => option?.id) || [];
            if (updatedIds.length > 0) {

                fetchLeadStatusReport(updatedIds, leadsStatus, dateObj, currentPage, perPage);
            }
            setIsFirstEffectRun(true);
            setPrevEmployeesIds_Test(updatedIds)
            setPrevstatus_Test(leadsStatus)
        }
    }, [selectedEmployeeOptions]);



    // Pagination handler
    const handlePageChange = (page) => {
        let leadsStatus = prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
        let updatedIds = selectedEmployeeOptions.map((userid) => userid?.id);
        setCurrentPage(page);
        fetchLeadStatusReport(updatedIds, leadsStatus, dateObj, page, perPage);
    };

    // handle per row change
    const handlePerRowsChange = (newPerPage, page) => {
        let leadsStatus = prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
        let updatedIds = selectedEmployeeOptions.map((userid) => userid?.id);
        setPerPage(newPerPage);
        setCurrentPage(page);
        fetchLeadStatusReport(updatedIds, leadsStatus, dateObj, page, newPerPage);
    };


    // Lead List Table data Submit data
    const handleApplySubmit = async () => {
        if (selectedEmployeeOptions.length === 0) {
            setError("You must select at least one");
        }
        else {
            let leadsStatus = prevstatus_Test.length > 0 ? prevstatus_Test : getLeadStatus.map((lead) => lead?.value) || [];
            let updatedIdss = selectedEmployeeOptions.map((userid) => userid?.id);
            fetchLeadStatusReport(updatedIdss, leadsStatus, dateObj, currentPage, perPage)
            setError("");
        }
    };
    useEffect(()=>{
        setGetLeadStatus(statusOptions)
    },[])


    return (
        <div>
             {remainingDays === 0 && isExpiredModalOpen && (
                    <SubExpired
                        onClose={handleClose}
                        profileData={profileData?.selectedPlanDetails?.planName}
                        remainingDays={remainingDays}
                    />
             )}
            <div className="page-content">
                <div className="container-fluid">
                    {/* title */}
                    <Row>
                        <BreadCrumb title="Lead Status Report" pageTitle="Lead Status Report" />
                    </Row>
                    {/*  */}
                    <Row>
                        <Card className="pt-4">
                            <div className="sn-lead-status-setting-btn">
                                <Link to="/Lead-Change-Status" className="sn-lead-changes-status btn btn-danger">
                                    <span className="ri-settings-4-line"></span> Setting
                                </Link>
                            </div>
                            <Row>
                                <div className="sn-report-lead-tabs">
                                    <Row className="sn-header-select-employess-home sn-team-managment-tble sn-top-inputs-heading">
                                        <Col sm={2}>
                                            <DatePicker
                                                labelContent="From Date"
                                                getDate={selectedFromDate}
                                                options={{
                                                    disable: [
                                                        {
                                                            from: new Date(),
                                                        },
                                                    ],
                                                    dateFormat: "d M, Y",
                                                    maxDate: new Date(
                                                        new Date().setDate(new Date().getDate())
                                                    ),
                                                }}
                                                onChange={handleFromDateChange}
                                            />
                                        </Col>

                                        <Col sm={2}>
                                            <DatePicker
                                                labelContent="To Date"
                                                getDate={selectedToDate}
                                                options={{
                                                    disable: [
                                                        {
                                                            from: new Date(),
                                                        },
                                                    ],
                                                    dateFormat: "d M, Y",
                                                    maxDate: new Date(
                                                        new Date().setDate(new Date().getDate())
                                                    ),
                                                }}

                                                onChange={handleToDateChange}
                                            />
                                        </Col>

                                        <Col sm={3}>
                                            <div className="sn-select-employee-droup-down-mt">
                                                <TeamSelect
                                                    setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                    teamIndu={teamIndu}
                                                    setTeamIndu={setTeamIndu}
                                                    labelContent="Select Team"
                                                />
                                            </div>
                                        </Col>

                                        <Col sm={3}>
                                            <div className="sn-select-employee-droup-down-mt">
                                                <EmployeeSelect
                                                    setEmployeeDefaultWithoutTeam={setEmployeeDefaultWithoutTeam}
                                                    EmployeeDefaultWithoutTeam={EmployeeDefaultWithoutTeam}
                                                    error={error}
                                                    setError={setError}
                                                    EmployeeDefault={teamIndu.length === 0 ? EmployeeDefaultWithoutTeam : EmployeeData}
                                                    setEmployeeDefault={setEmployeeData}
                                                    teamIndu={teamIndu}
                                                    selectedEmployeeOptions={selectedEmployeeOptions}
                                                    setSelectedEmployeeOptions={setSelectedEmployeeOptions}
                                                    setSelectedEmployeeOptions2={setSelectedEmployeeOptions2}
                                                    labelContent="Select Employee"
                                                />
                                            </div>
                                        </Col>

                                        <Col sm={2} className="sn-header-select-employess-home">
                                            <CommonLabel htmlFor="leadstatus">
                                                Select Lead Status
                                            </CommonLabel>

                                            <MultiSelect
                                                options={statusOptions}
                                                value={getLeadStatus}
                                                onChange={handleStatusChange}
                                                labelledBy={"Select"}
                                                isCreatable={true}
                                                overrideStrings={{ selectSomeItems: "Select Leads" }}
                                                hasSelectAll={true}
                                                className=" mb-0"
                                            />
                                            {statusError && (
                                                <small
                                                    className="sales-ninja-select-maltipale-lable"
                                                    style={{
                                                        color: "red",
                                                        position: "absolute",
                                                        bottom: "px",
                                                        left: "22px",
                                                    }}
                                                >
                                                    <span></span>
                                                    {statusError}
                                                </small>
                                            )}
                                        </Col>


                                        <Col sm={2}>
                                            <FormGroup>
                                                <Label for="exampleSelect"></Label>
                                                <div id="exampleSelect" className="sn-call-apply-btn-reset">
                                                    <Button
                                                        id="exampleSelect"
                                                        type="submit"
                                                        color="danger"
                                                        className=""
                                                        onClick={handleApplySubmit}
                                                    // disabled={isLoading}
                                                    >
                                                        Apply
                                                    </Button>
                                                    <Button
                                                        className=""
                                                        style={{
                                                            marginLeft: "10px",
                                                        }}
                                                        id="exampleSelect"
                                                        outline
                                                        color="danger"
                                                    >
                                                        Reset
                                                    </Button>
                                                </div>
                                            </FormGroup>
                                        </Col>

                                        {/* <Col sm={2}>
                                            <div className="mb-3">
                                                <label htmlFor="reminder" className="form-label">
                                                    Select Reminder
                                                </label>
                                                <select
                                                    name="reminder"
                                                    className="form-select"
                                                    value={selectedOption}
                                                    onChange={handleSelectChange}
                                                >
                                                    <option value="Select">Select</option>
                                                    <option value="After">After</option>
                                                    <option value="Before">Before</option>
                                                    <option value="Between">Between</option>
                                                </select>
                                            </div>
                                        </Col> */}

                                    </Row>
                                </div>
                            </Row>
                            <Row>
                                <Col sm="12 sn-table-height-Common">
                                    <LeadDataTable
                                        columns={columns}
                                        data={leadStatusReport}
                                        paginationTotalRows={totalRows}
                                        progressPending={isLoading}
                                        onChangePage={(page) => handlePageChange(page)}
                                        onChangeRowsPerPage={(newPerPage) => handlePerRowsChange(newPerPage)}
                                    />

                                </Col>
                            </Row>
                        </Card>
                    </Row>
                </div>
            </div>
        </div>
    );
};

export default LeadStatusReport;
